import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    Typography,
    Grid,
    Card,
    Divider,
    CardContent,
    IconButton,
    Avatar,
    Chip,
    Button
} from "@mui/material";
import { RxCross2 } from "react-icons/rx";
import moment from "moment";
import StatusBadge from "components/badge/StatusBadge";

const ViewLeads = (props) => {
    const { open, handleClose, rowData } = props;

    const labelStyle = {
        fontSize: "14px",
        color: "#6b7280",
        display: "flex",
        alignItems: "center",
        gap: "4px",
    };

    const valueStyle = {
        fontSize: "15px",
        color: "#111827",
        fontWeight: 500,
        mt: 0.5,
    };

    const formatINR = (value) => {
        if (!value && value !== 0) return "N/A";
        return Number(value).toLocaleString("en-IN");
    };

    return (
        <>
            <Dialog
                open={open}
                fullWidth
                maxWidth="md"
                PaperProps={{
                    sx: {
                        borderTopLeftRadius: "5px",
                        borderTopRightRadius: "5px",
                        backgroundColor: "#FFFFFF",
                        width: "100%",
                        overflowX: "hidden"
                    },
                }}
                disableEscapeKeyDown
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose();
                    }
                }}
            >
                <DialogTitle sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #ddd",
                    backgroundColor: "#ECECEC",
                    pb: 2,
                    pt: 3,
                    width: "100%",
                }}>
                    <Typography sx={{
                        fontWeight: 600,
                        fontSize: "27px",
                        lineHeight: "100%",
                        color: "#140F36",
                        fontFamily: "Outfit, sans-serif"
                    }}>
                        View Deal Details
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={() => handleClose()}
                        sx={(theme) => ({
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: theme.palette.grey[500],
                        })}
                    >
                        <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <Card
                        elevation={0}
                        sx={{
                            borderRadius: "3px",
                            border: "1px solid #e5e7eb",
                            backgroundColor: "#fff",
                            p: 2,
                        }}
                    >
                        {/* Header */}
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mb: 1,
                            }}
                        >
                            <Typography sx={{ fontWeight: 600, fontSize: "16px" }}>
                                Deal Information
                            </Typography>
                        </Box>

                        <Divider sx={{ mb: 2 }} />

                        <CardContent sx={{ pt: 0 }}>
                            <Grid container spacing={2}>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Lead Name:</Typography>
                                    <Typography sx={valueStyle}>{rowData?.leadName ?? "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Deal Name:</Typography>
                                    <Typography sx={valueStyle}>{rowData?.name ?? "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Asset Type:</Typography>
                                    <Typography sx={valueStyle}>{rowData?.assetType ? rowData?.assetType : "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Area In Sqft:</Typography>
                                    <Typography sx={valueStyle}>{formatINR(rowData?.area)}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>LOI Signed Date:</Typography>
                                    <Typography sx={valueStyle}>
                                        {rowData?.loiSignedDate ? moment.utc(rowData?.loiSignedDate).format("DD MMM YYYY") : "N/A"}
                                    </Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Model Rental Rate:</Typography>
                                    <Typography sx={valueStyle}>{formatINR(rowData?.modelRentalRate)}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Deal Rental Base:</Typography>
                                    <Typography sx={valueStyle}>{formatINR(rowData?.dealRentalBase)}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Deal Rental CAM:</Typography>
                                    <Typography sx={valueStyle}>{formatINR(rowData?.dealRentalCam)}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Deal Rental TI:</Typography>
                                    <Typography sx={valueStyle}>{formatINR(rowData?.dealRentalTi)}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>LCD:</Typography>
                                    <Typography sx={valueStyle}>
                                        {rowData?.lcd ? moment.utc(rowData?.lcd).format("DD MMM YYYY") : "N/A"}
                                    </Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Rent Free Months:</Typography>
                                    <Typography sx={valueStyle}>{rowData?.rentFreeMonths ? rowData?.rentFreeMonths : "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>RCD:</Typography>
                                    <Typography sx={valueStyle}>
                                        {rowData?.rcd ? moment.utc(rowData?.rcd).format("DD MMM YYYY") : "N/A"}
                                    </Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Escalation:</Typography>
                                    <Typography sx={valueStyle}>{rowData?.escalation ? rowData?.escalation : "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Notice Period (Days):</Typography>
                                    <Typography sx={valueStyle}>{rowData?.noticePeriodDays ? rowData?.noticePeriodDays : "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Security Deposite Amount:</Typography>
                                    <Typography sx={valueStyle}>{rowData?.securityDeposit ? rowData?.securityDeposit : "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Utilities Amount:</Typography>
                                    <Typography sx={valueStyle}>{rowData?.utilities ? rowData?.utilities : "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Stamp Duty (Lesse):</Typography>
                                    <Typography sx={valueStyle}>{rowData?.stampDutyLessee ? rowData?.stampDutyLessee : "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Stamp Duty (Lessor):</Typography>
                                    <Typography sx={valueStyle}>{formatINR(rowData?.stampDutyLessor)}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Handover Date:</Typography>
                                    <Typography sx={valueStyle}>
                                        {rowData?.handoverDate ? moment.utc(rowData?.handoverDate).format("DD MMM YYYY") : "N/A"}
                                    </Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Lease to Handover (Days):</Typography>
                                    <Typography sx={valueStyle}>{rowData?.leaseToHandoverDays ? rowData?.leaseToHandoverDays : "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Post Handover Esclations:</Typography>
                                    <Typography sx={valueStyle}>{rowData?.postHandoverEscalations ? rowData?.postHandoverEscalations : "N/A"}</Typography>
                                </Grid>

                                <Grid size={12}>
                                    <Typography sx={labelStyle}>Rental Comments:</Typography>
                                    <Typography sx={{ ...valueStyle, whiteSpace: "pre-line" }}>{rowData?.rentalComments ?? "N/A"}</Typography>
                                </Grid>

                            </Grid>
                        </CardContent>
                    </Card>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default ViewLeads;